import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";

const SocialMedia = ({ formik }) => {
  return (
    <>
      <Box>
        <Typography variant="h4">Social Media Task</Typography>
        <Box>
          <Typography variant="h6">Instructions</Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Box>
              <List>
                <Typography gutterBottom>
                  1. Record a video answering (max duration: 1 minute 30 secs)
                </Typography>

                <ListItem>
                  <ListItemText primary="what is your name?" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="What do you do?" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="How did you hear about the bootcamp?" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="What are your fears when you hear tech?" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="What will this opportunity do for you or how do you plan to maximise this opportunity?" />
                </ListItem>
              </List>
            </Box>
            <Box>
              <Typography>
                2. Upload the video on X(Twitter) or LinkedIn
              </Typography>
            </Box>
            <Box>
              <List>
                <Typography gutterBottom>
                  3. Tag us and use these hashtags
                </Typography>

                <ListItem>
                  <ListItemText primary="#NTcohort1 #NTbootcamp #Nexarux" />
                </ListItem>
              </List>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ marginBottom: "10px" }}>
                Enter your post link for X and your post link for LinkedIn
                respectively
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-Between",
                  flexWrap: "wrap",
                  alignItems: "flex-start",
                  gap: "15px",
                }}
              >
                <Box>
                  <TextField
                    type="text"
                    name="x_post_link"
                    label="X(Twitter)"
                    value={formik.values.x_post_link}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.x_post_link && formik.errors.x_post_link ? (
                    <Typography sx={{ color: "#ff0000" }}>
                      {formik.errors.x_post_link}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Box>
                <Box>
                  <TextField
                    type="text"
                    name="linkedin_post_link"
                    label="LinkedIn"
                    value={formik.values.linkedin_post_link}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    autoFocus
                  />
                  {formik.touched.linkedin_post_link &&
                  formik.errors.linkedin_post_link ? (
                    <Typography sx={{ color: "#ff0000" }}>
                      {formik.errors.linkedin_post_link}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SocialMedia;
